import ArtGalleryModal from './ArtGalleryModal';
import FolkvangrModal from './FolkvangrModal';
import RecruitmentChallengeModal from './RecruitmentChallengeModal';

// Maps a project's `modalKey` (set in portfolioContent.js) to its
// independent modal component. Add a new entry here whenever a project
// needs its own custom modal layout.
const modalRegistry = {
  artGallery: ArtGalleryModal,
  folkvangr: FolkvangrModal,
  recruitmentChallenge: RecruitmentChallengeModal,
};

export default modalRegistry;
